<template>
  <!--  排行榜  -->
  <el-dialog  :close-on-click-modal="false" title="绩效排行榜"
              :visible.sync="dialogVisible"
              width="700px" v-el-drag-dialog
              @close="closeDialog">
    <ul class="rank-box">
      <li v-if="formData.companyTopList.length>0">
        <h4>公司排行榜</h4>
        <div class="item-box">
          <div v-for="(it,a) in formData.companyTopList" :key="a" class="item">
            <i :class="{'name1':a==0,'name2':a==1,'name3':a==2}">{{a+1}}</i><span class="d-in-block w100">{{it.name}}</span><span class="d-in-block score-box">{{it.score}}</span>
            <b :class="it.className"></b>
          </div>
        </div>
      </li>
      <li v-if="formData.staffTopList.length>0">
        <h4>人员排行榜</h4>
        <div class="item-box">
          <div v-for="(it,a) in formData.staffTopList" :key="a" class="item">
            <i :class="{'name1':a==0,'name2':a==1,'name3':a==2}">{{a+1}}</i><span class="d-in-block w100">{{it.name}}</span><span class="d-in-block score-box">{{it.score}}</span>
            <b :class="it.className"></b>
          </div>
        </div>
      </li>
    </ul>
  </el-dialog>
</template>
<script>

export default {
  name: "rankDialog",
  data(){
    return{
      dialogVisible:false,
      formData:{companyTopList:[],staffTopList:[]},
    }
  },
  mounted() {
    this.getRankTop()
  },
  methods:{
    // 获取绩效排行榜
    getRankTop(){
      this.$axios.get(this.api.performance.kpiAssessReportTop).then(res => {
        console.log(res)
        if(res.data.code==200){
          this.formData=res.data.result
          if(this.formData.companyTopList.length==0&&this.formData.staffTopList.length==0){
            this.dialogVisible=false;
            return false;
          }
          this.formData.companyTopList.length>=1?this.formData.companyTopList[0].className='el-icon-deythuangguan':null
          this.formData.companyTopList.length>=2?this.formData.companyTopList[1].className='el-icon-deythuiyuanzuanshi-xianxing':null
          this.formData.companyTopList.length>=3?this.formData.companyTopList[2].className='el-icon-deytxing_mian':null
          this.formData.staffTopList.length>=1?this.formData.staffTopList[0].className='el-icon-deythuangguan':null
          this.formData.staffTopList.length>=2?this.formData.staffTopList[1].className='el-icon-deythuiyuanzuanshi-xianxing':null
          this.formData.staffTopList.length>=3?this.formData.staffTopList[2].className='el-icon-deytxing_mian':null
          this.dialogVisible=true;
        }
      })
    },
    /*关闭弹框=*/
    closeDialog(){
      this.dialogVisible=false
    },
  }
}
</script>
<style scoped lang="scss">
.rank-box{
  display: flex;
  h4{text-align: center;margin-bottom: 15px}
  .item-box{width: 20%;min-width: 280px;border: 1px solid #aaa;padding: 15px;max-height: 550px;overflow-y: auto;}
  li+li{margin-left: 40px}
  .item{
    i{background: #696969;font-size: 12px;font-weight: bolder;border-radius: 50%;color: #fff;font-style: normal;width: 25px;display: inline-block;height: 25px;text-align: center;line-height: 25px;}
    .name1{background: rgba(255, 215, 0,0.5);color:#E6A23C}
    .name2{background: rgba(192, 192, 192,0.5);color:#C0C0C0}
    .name3{background: rgba(191,173,111,0.5);color:#B87333}
    .score-box{width: 50px;font-weight: bolder;color: #6767ec
    }
    span{margin-left: 20px}
    margin-bottom: 15px;
    .el-icon-deythuangguan{color: #FFD700}
    .el-icon-deythuiyuanzuanshi-xianxing{color: #C0C0C0}
    .el-icon-deytxing_mian{color: #B87333}
  }
  padding-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/index/rankDialog.vue